var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconActions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.858,
    height: 18.568,
    viewBox: "0 0 11.858 18.568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_action_3451742",
    transform: "translate(-3.031 -0.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48477",
    "data-name": "Group 48477",
    transform: "translate(3.165 0.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48476",
    "data-name": "Group 48476"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71113",
    "data-name": "Path 71113",
    d: "M694.158,482.068a4.878,4.878,0,0,0-1.387,9.6v1.415a2.128,2.128,0,0,0-1.525-.645h-.305a.3.3,0,0,0-.289.4,6.481,6.481,0,0,1,.289,1.734v3.355a2.442,2.442,0,0,0,2.44,2.44h1.22v-.61h-1.22a1.82,1.82,0,0,1-1.83-1.83v-3.355a5.787,5.787,0,0,0-.207-1.505,1.51,1.51,0,0,1,1.427,1.505V496.1h.61v-8.541a.61.61,0,1,1,1.22,0v6.1h.61v-1.83a.61.61,0,1,1,1.22,0v2.44h.61v-1.83a.61.61,0,1,1,1.22,0v2.44h.61v-1.83a.61.61,0,1,1,1.22,0v6.1a.606.606,0,0,1-.61.61v.61a1.225,1.225,0,0,0,1.22-1.22v-6.1a1.225,1.225,0,0,0-1.22-1.22,1.212,1.212,0,0,1-1.83-.61.5.5,0,0,1-.942-.219,4.88,4.88,0,0,0-2.552-8.93Zm-.02.609a4.269,4.269,0,0,1,1.977,7.97,1.153,1.153,0,0,0-.9.13v-1.039a3.048,3.048,0,1,0-2.44,0v1.3a4.271,4.271,0,0,1,1.367-8.361Z",
    transform: "translate(-689.11 -482.065)",
    fill: "#f45e29",
    stroke: "#f45e29",
    strokeWidth: 0.265
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActions);
export default __webpack_public_path__ + "static/media/icon-actions.9c2e3e11.svg";
export { ForwardRef as ReactComponent };